import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import Dashboard from "./Dashboard";

export default function Reports() {
  return <Dashboard />;
}
